import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  border-radius: inherit;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  flex-grow: 0;\n  flex-shrink: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import Backdrop from '../../Backdrop';
import styled from 'styled-components';
import { CARD_BORDER_RADIUS_EXTRA_LARGE, CARD_BORDER_RADIUS_LARGE, CARD_BORDER_RADIUS_MEDIUM, CARD_BORDER_RADIUS_SMALL } from '../../constants';
import { zIndexMixin } from '../../mixins/layout';
import { INFO_CARD_IMAGE_BUTTON_OFFSET, INFO_CARD_IMAGE_CHIP_TOP_OFFSET, INFO_CARD_IMAGE_HEIGHT_EXTRA_SMALL, INFO_CARD_IMAGE_HEIGHT_LARGE, INFO_CARD_IMAGE_HEIGHT_MEDIUM, INFO_CARD_IMAGE_HEIGHT_SMALL, INFO_CARD_IMAGE_HEIGHT_TINY, INFO_CARD_IMAGE_ICON_OFFSET } from './constants';
import { getPx } from '../../helpers/common';
import { isDefined } from '../../helpers/defined';
import { fullSpaceAbsoluteStyle } from '../../tokens/full-space';
import { overflowHiddenStyle } from '../../tokens/overflow';
import { borderBottomRadiusStyle, borderLeftRadiusStyle, borderRightRadiusStyle, borderTopRadiusStyle } from '../../tokens/border-radius';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../helpers/media-style';
import { height } from '../../style/height';
import { width } from '../../style/width';
import { left } from '../../style/left';
import { right } from '../../style/right';
import { top } from '../../style/top';
var BORDER_RADIUS = {
  small: CARD_BORDER_RADIUS_SMALL,
  medium: CARD_BORDER_RADIUS_MEDIUM,
  large: CARD_BORDER_RADIUS_LARGE,
  'extra-large': CARD_BORDER_RADIUS_EXTRA_LARGE
};
var HEIGHT = {
  'extra-small': INFO_CARD_IMAGE_HEIGHT_EXTRA_SMALL,
  tiny: INFO_CARD_IMAGE_HEIGHT_TINY,
  small: INFO_CARD_IMAGE_HEIGHT_SMALL,
  medium: INFO_CARD_IMAGE_HEIGHT_MEDIUM,
  large: INFO_CARD_IMAGE_HEIGHT_LARGE
};
var ImageWrapper = styled.div(_templateObject(), function (_ref) {
  var $position = _ref.$position;
  return styleForBreakpoints($position, function ($position) {
    return (
      /* prettier-ignore */
      $position === 'top' ? "border-bottom-width: 0 !important;" : $position === 'bottom' ? "border-top-width: 0 !important;" : $position === 'left' ? "border-right-width: 0 !important;" : $position === 'right' ? "border-left-width: 0 !important;" : ''
    );
  });
}, function (_ref2) {
  var $withOverflowHidden = _ref2.$withOverflowHidden;
  return $withOverflowHidden ? "\n        overflow: hidden;\n        " + overflowHiddenStyle + "\n      " : '';
}, function (_ref3) {
  var $width = _ref3.$width;
  return width($width);
}, function (_ref4) {
  var _ref4$$variant = _ref4.$variant,
      $variant = _ref4$$variant === void 0 ? 'small' : _ref4$$variant,
      $height = _ref4.$height;
  return $height !== null ? height($height != null ? $height : HEIGHT[$variant] || HEIGHT.small) : '';
}, function (_ref5) {
  var $position = _ref5.$position,
      $size = _ref5.$size,
      $borderRadius = _ref5.$borderRadius;
  return styleArrayForBreakpoints([$position, BORDER_RADIUS[$size] || BORDER_RADIUS.medium, $borderRadius], function (_ref6) {
    var $position = _ref6[0],
        $radius = _ref6[1],
        $borderRadius = _ref6[2];
    var value = $borderRadius != null ? $borderRadius : $radius;
    return $position === 'top' ? isDefined($borderRadius) || $size ? "border-radius: " + getPx(value) + " " + getPx(value) + " 0 0;" : borderTopRadiusStyle : $position === 'bottom' ? isDefined($borderRadius) || $size ? "border-radius: 0 0 " + getPx(value) + " " + getPx(value) + ";" : borderBottomRadiusStyle : $position === 'left' ? isDefined($borderRadius) || $size ? "border-radius: " + getPx(value) + " 0 0 " + getPx(value) + ";" : borderLeftRadiusStyle : $position === 'right' ? isDefined($borderRadius) || $size ? "border-radius: 0 " + getPx(value) + " " + getPx(value) + " 0;" : borderRightRadiusStyle : '';
  });
}, function (_ref7) {
  var $backgroundColor = _ref7.$backgroundColor;
  return $backgroundColor ? "background-color: " + $backgroundColor + ";" : '';
});
var ImagePlaceholder = styled.div(_templateObject2(), function (_ref8) {
  var $height = _ref8.$height;
  return $height !== null ? fullSpaceAbsoluteStyle : "height: 100%;";
}, zIndexMixin);
var TopRightIconWrapper = styled.div(_templateObject3(), right(INFO_CARD_IMAGE_ICON_OFFSET), top(INFO_CARD_IMAGE_ICON_OFFSET), zIndexMixin);
var TopLeftIconWrapper = styled.div(_templateObject4(), left(INFO_CARD_IMAGE_ICON_OFFSET), top(INFO_CARD_IMAGE_ICON_OFFSET), zIndexMixin);
var TopRightButtonWrapper = styled.div(_templateObject5(), right(INFO_CARD_IMAGE_BUTTON_OFFSET), top(INFO_CARD_IMAGE_BUTTON_OFFSET), zIndexMixin);
var TopLeftButtonWrapper = styled.div(_templateObject6(), left(INFO_CARD_IMAGE_BUTTON_OFFSET), top(INFO_CARD_IMAGE_BUTTON_OFFSET), zIndexMixin);
var TopRightChipWrapper = styled.div(_templateObject7(), right(INFO_CARD_IMAGE_BUTTON_OFFSET), top(INFO_CARD_IMAGE_CHIP_TOP_OFFSET), zIndexMixin);
var TopLeftChipWrapper = styled.div(_templateObject8(), left(INFO_CARD_IMAGE_BUTTON_OFFSET), top(INFO_CARD_IMAGE_CHIP_TOP_OFFSET), zIndexMixin);

var InfoCardImage = function InfoCardImage(_ref9) {
  var _ref9$withOverflowHid = _ref9.withOverflowHidden,
      withOverflowHidden = _ref9$withOverflowHid === void 0 ? false : _ref9$withOverflowHid,
      imageHeight = _ref9.imageHeight,
      _ref9$imageWidth = _ref9.imageWidth,
      imageWidth = _ref9$imageWidth === void 0 ? '100%' : _ref9$imageWidth,
      _ref9$imagePosition = _ref9.imagePosition,
      imagePosition = _ref9$imagePosition === void 0 ? 'top' : _ref9$imagePosition,
      _ref9$imageSize = _ref9.imageSize,
      imageSize = _ref9$imageSize === void 0 ? 'small' : _ref9$imageSize,
      imageBorderRadius = _ref9.imageBorderRadius,
      image = _ref9.image,
      topRightIcon = _ref9.topRightIcon,
      topLeftIcon = _ref9.topLeftIcon,
      topRightButton = _ref9.topRightButton,
      topLeftButton = _ref9.topLeftButton,
      topRightChip = _ref9.topRightChip,
      topLeftChip = _ref9.topLeftChip,
      size = _ref9.size,
      backgroundColor = _ref9.backgroundColor,
      children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, ["withOverflowHidden", "imageHeight", "imageWidth", "imagePosition", "imageSize", "imageBorderRadius", "image", "topRightIcon", "topLeftIcon", "topRightButton", "topLeftButton", "topRightChip", "topLeftChip", "size", "backgroundColor", "children"]);

  return /*#__PURE__*/React.createElement(ImageWrapper, _extends({
    $withOverflowHidden: withOverflowHidden,
    $position: imagePosition,
    $variant: imageSize,
    $height: imageHeight,
    $width: imageWidth,
    $size: size,
    $borderRadius: imageBorderRadius,
    $backgroundColor: backgroundColor
  }, props), /*#__PURE__*/React.createElement(ImagePlaceholder, {
    $height: imageHeight,
    $width: imageWidth,
    $zIndex: 1
  }, image || children), (topRightIcon || topLeftIcon) && /*#__PURE__*/React.createElement(Backdrop, {
    zIndex: 2,
    position: imagePosition,
    height: '50%'
  }), topRightIcon && /*#__PURE__*/React.createElement(TopRightIconWrapper, {
    $zIndex: 3
  }, topRightIcon), topLeftIcon && /*#__PURE__*/React.createElement(TopLeftIconWrapper, {
    $zIndex: 3
  }, topLeftIcon), topRightButton && /*#__PURE__*/React.createElement(TopRightButtonWrapper, {
    $zIndex: 4
  }, topRightButton), topLeftButton && /*#__PURE__*/React.createElement(TopLeftButtonWrapper, {
    $zIndex: 4
  }, topLeftButton), topRightChip && /*#__PURE__*/React.createElement(TopRightChipWrapper, {
    $zIndex: 5
  }, topRightChip), topLeftChip && /*#__PURE__*/React.createElement(TopLeftChipWrapper, {
    $zIndex: 5
  }, topLeftChip));
};

export default InfoCardImage;